'use strict';

angular.module('atex.dam').factory('DamAuthorService', [ '$q', '$http', 'AssignService', 'UserProfileService', 'AuthenticationService', 'DamService', 'SearchService', 'ContentService', 'configuration', '$rootScope', '$modal',
  function ($q, $http, AssignService, UserProfileService, AuthenticationService, DamService, SearchService, ContentService, configuration, $rootScope, $modal) {

    var authorSecParentId = "dam.assets.common.d";

    function DamAuthorService() {}

    DamAuthorService.createAuthor = function (authorContentData) {
      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        var transferInfo = {
          data: authorContentData
        };
        transferInfo.data.aspects['p.InsertionInfo'] = {
          data: {
            _type: 'p.InsertionInfo',
            securityParentId: 'externalid/' + authorSecParentId
          }
        };
        transferInfo.data.aspects['atex.dam.standard.ContentAccess'] = {
          data: {
            _type: 'atex.dam.standard.ContentAccess',
            "assignees": [
              {
                "externalId": currentUserInfo.externalId,
                "owner": true
              }
            ],
            "creator": currentUserInfo.externalId
          }
        };
        return ContentService.createContent(transferInfo).then(function (response) {
          return ContentService.getContent({id: response.id});
        });
      });
    };

    DamAuthorService.updateAuthor = function(transferInfo) {
      return ContentService.updateContent(transferInfo);
    };

    DamAuthorService.deleteAuthor = function (id) {
        return this.getAuthor(id).then(function (author) {
            return ContentService.deleteContent({id: author.id, revision: author.revision}).then(function () {
                return author;
            });
        });
    };

    DamAuthorService.getAuthor = function(id)  {
        return ContentService.getContent({id: id});
    };

    DamAuthorService.setOwnerDetails = function (author) {
      DamService.getCurrentDamUserInfo().then(function (userInfo) {
        var access = author.aspects['atex.dam.standard.ContentAccess'];
        var assignees = access ? access.data.assignees : undefined;
        var owners = AssignService.getOwnersFromAssignees(assignees);
        author.isOwner = userInfo.isAdm || AssignService.isUserOwner(userInfo.externalId, userInfo.groups, owners);
        author.isInherited = access && access.data && access.data.creator && access.data.creator !== userInfo.externalId;
        author.isDefault = false;

        if (userInfo.userData && userInfo.userData.relations) {
          var defaultId = userInfo.userData.relations['default-author'];
          if (defaultId === author.id) {
            author.isDefault = true;
          }
        }
      });
    };

    DamAuthorService.makeDefault = function (authors, selected) {
      var authorId = authors[selected].id;
      DamService.setUserRelation("default-author", authorId ).then ( function () {
        authors.forEach(function (author) {
          author.isDefault = false;
        });
        authors[selected].isDefault = true;
      });
    };

    DamAuthorService.searchAuthors = function(_options)  {
      var options = {};
      if (typeof _options === 'object' && _options !== null) {
        options = _options;
      } else {
        options.filter = _options;
      }
      var filter = options.filter;
      var query = options.query;
      var maxRows = options.maxRows || configuration.getMaxAuthorsRowsQuery() || 50;
      var start = options.start || 0;
      var fulltext = options.fulltext || false;

      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        return DamService.getSolrServerInfo().then(function (solrInfo) {
          var transferInfo = {};
          transferInfo['start'] = start;
          transferInfo['rows'] = maxRows;
          transferInfo['core'] = solrInfo.solrCore;
          transferInfo['variant'] = 'list';
          transferInfo['fl'] = 'id';
          transferInfo['q'] = query || '*:* ';
          transferInfo['fq'] = '+type:(atex.dam.standard.Author)';
          transferInfo['sort'] = 'name_atex_desk_alphaSort asc';
          if (filter) {
            var field = fulltext ? 'atex_desk_text' : 'name_atex_desk_ts';
            var processedFilter = filter.trim();
            if (processedFilter.indexOf('text:') === 0) {
              field = 'atex_desk_text';
              processedFilter = processedFilter.substring(5);
            }
            var doubleQuotesFilter = processedFilter.match(/".*?"/g);

            var splitWithAnd = function(filter) {
              var trimmed = filter.trim();
              if (trimmed.length === 0) {
                return '';
              }
              return trimmed
                .replaceAll('"', '\\"')
                .split(/\s+/)
                .map(function(s) { return '*' + s + '*'; })
                .join(' AND ');
            };

            var andFilter = '';
            if (doubleQuotesFilter) {
              for (var idx = 0; idx < doubleQuotesFilter.length; idx++) {
                var dbf = doubleQuotesFilter[idx];
                var fIdx = processedFilter.indexOf(dbf);
                if (andFilter.length > 0) {
                  andFilter += ' AND ';
                }
                var newFilter = splitWithAnd(processedFilter.substring(0, fIdx));
                if (newFilter.length > 0) {
                  newFilter += ' AND ';
                }
                andFilter += newFilter + dbf;
                processedFilter = processedFilter.substring(fIdx + dbf.length);
              }
            }

            if (processedFilter.length > 0) {
              if (andFilter.length > 0) {
                andFilter += ' AND ';
              }
              andFilter += splitWithAnd(processedFilter);
            }
            andFilter = andFilter.trim();
            transferInfo['q'] = '+' + field + ':(' + andFilter + ')';
          }

          if (configuration.getFilterAuthorsList() && !currentUserInfo.isAdm) {
            transferInfo['q'] += '+assignees_atex_desk_sms:(';
            transferInfo['q'] += currentUserInfo.externalId;
            for (var i = 0; currentUserInfo.groups && i < currentUserInfo.groups.length; i++) {
              var escaped = currentUserInfo.groups[i].principalId.replace(':', '\\:');
              transferInfo['q'] += ' OR ' + escaped;
            }
            transferInfo['q'] += ')';
          }

          return SearchService.search(transferInfo).then (function (response) {
            var numFound = 0;
            var result = [];
            if (response && response.data.response.docs) {
              numFound = response.data.response.numFound;
              response.data.response.docs.forEach(function (doc) {
                var author = doc._data;
                if (typeof author !== 'undefined') {
                  DamAuthorService.setOwnerDetails(author, currentUserInfo);
                  result.push(author);
                }
              });
            }
            result.sort(function(a, b) {
              var nameA = a.aspects.contentData.data.name.toUpperCase(); // ignore upper and lowercase
              var nameB = b.aspects.contentData.data.name.toUpperCase(); // ignore upper and lowercase
              return nameA.localeCompare(nameB, undefined, {numeric: true, sensitivity: 'base'});
            });
            return {
              numFound: numFound,
              start: start,
              next: Math.max(0, start + maxRows),
              prev: Math.max(0, start - maxRows),
              authors: result
            };
          });
        });
      });
    };

    DamAuthorService.createModal = function(isNew, id, template, callBack) {
      var modalScope = $rootScope.$new(true);
      if (id) {
        modalScope.id = id;
      }
      modalScope.isNew = isNew;
      var modalEl;
      $modal({
        show: true,
        scope: modalScope,
        template: template,
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      }).then(function(_modalEl){
        modalEl = _modalEl;
        // allow modal fields to be focusable
        // https://stackoverflow.com/questions/32911355/whats-the-tabindex-1-in-bootstrap-for
        $(".dam-modal-edit").removeAttr("tabIndex");
      });
      var destroyModal = function () {
        modalEl.on('hidden.bs.modal', function () {
          modalScope.$destroy();
          angular.element(this).remove();
        });
        modalEl.modal('hide');
      };
      modalScope.doCancel = function () {
        destroyModal();
      };
      modalScope.doOk = function (response) {
        if (callBack) {
          callBack(response);
        }
        destroyModal();
      };
    };

    DamAuthorService.loadAuthorByLoginName = function(loginname)  {
      return DamService.getSolrServerInfo().then(function (solrInfo) {
        var transferInfo = {};
        transferInfo['start'] = 0;
        transferInfo['rows'] = 1;
        transferInfo['core'] = solrInfo.solrCore;
        transferInfo['variant'] = 'list';
        transferInfo['fl'] = 'id';
        transferInfo['q'] = '+loginname_atex_desk_ts:(' + loginname + ')';
        transferInfo['fq'] = '+type:(atex.dam.standard.Author)';
        return SearchService.search(transferInfo).then (function (response) {
          if (response && response.data.response.numFound>0) {
            return ContentService.getContent({id: response.data.response.docs[0].id});
          }
        });
      });
    };

    return (DamAuthorService);
  }]);
